module.exports = __webpack_public_path__ + "img/bastien-grivet-the-door.70389a6.jpg";